import { jsx as o } from "@emotion/react/jsx-runtime";
import { createElement as i } from "react";
import { Stack as m } from "@partoohub/ui";
import { CheckboxFilterView as p } from "./subComponents/FilterView/Checkbox/CheckboxFilterView.js";
import { RadioFilterView as l } from "./subComponents/FilterView/Radio/RadioFilterView.js";
import { SelectableFilterView as a } from "./subComponents/FilterView/SelectableCheckboxCard/SelectableFilterView.js";
import { SelectableRadioFilterView as n } from "./subComponents/FilterView/SelectableRadioCard/SelectableRadioFilterView.js";
import { SingleSelectFilterView as c } from "./subComponents/FilterView/SingleSelect/SingleSelectFilterView.js";
import { FilterCategory as e } from "../../types/components/dynamicFilters.types.js";
const V = ({
  section: r
}) => {
  const t = {
    [e.CHECKBOX]: p,
    [e.SELECTABLE]: a,
    [e.SELECTABLE_RADIO]: n,
    [e.RADIO]: l,
    [e.SINGLE_SELECT]: c
  }[r.filterCategory];
  return /* @__PURE__ */ o(m, { gap: "8px", children: i(t, {
    filterMeta: {
      id: r?.id,
      property: r?.property,
      sectionName: r?.sectionName,
      options: r?.options ?? [],
      numberPerLine: r?.numberPerLine
    }
  }) });
};
export {
  V as DynamicFramework
};
